export const ON_SIMPLE_VALUE_CHANGED = "dialogs@ON_SIMPLE_VALUE_CHANGED";
